export default __webpack_public_path__ + "static/media/a.9e340543.svg";